var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02514 0.677488C1.20137 0.501313 1.44036 0.402344 1.68954 0.402344C1.93873 0.402344 2.17771 0.501313 2.35394 0.677488L7.00567 5.32922L11.6574 0.677488C11.8346 0.506306 12.072 0.411585 12.3184 0.413727C12.5648 0.415868 12.8005 0.514699 12.9748 0.688935C13.149 0.863172 13.2478 1.09887 13.25 1.34527C13.2521 1.59167 13.1574 1.82905 12.9862 2.00629L7.67007 7.32242C7.49384 7.49859 7.25486 7.59756 7.00567 7.59756C6.75649 7.59756 6.5175 7.49859 6.34127 7.32242L1.02514 2.00629C0.84897 1.83006 0.75 1.59107 0.75 1.34189C0.75 1.0927 0.84897 0.853716 1.02514 0.677488Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.67a24df14503202bbcbee15535c28554.svg";
export { ForwardRef as ReactComponent };